
import { useCompare } from '../context/CompareContext';

export default function CompareBar() {
  const { compareItems, removeFromCompare, openCompare, clearCompare } = useCompare();

  if (compareItems.length === 0) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-stone-200 shadow-2xl shadow-stone-900/10 animate-in slide-in-from-bottom duration-300">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between gap-6">
          {/* Left: Compare Items */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <i className="ri-scales-3-line text-amber-500 text-xl"></i>
              <span className="text-stone-600 font-medium text-sm">
                Compare ({compareItems.length}/3)
              </span>
            </div>
            
            <div className="flex items-center gap-3">
              {compareItems.map((item) => (
                <div
                  key={item.id}
                  className="relative group flex items-center gap-2 bg-stone-50 rounded-full pl-2 pr-3 py-1.5"
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-8 h-8 rounded-full object-cover bg-white"
                  />
                  <span className="text-sm text-stone-700 font-medium max-w-24 truncate">
                    {item.name.split(' ').slice(0, 2).join(' ')}
                  </span>
                  <button
                    onClick={() => removeFromCompare(item.id)}
                    className="w-5 h-5 rounded-full bg-stone-200 hover:bg-rose-100 flex items-center justify-center cursor-pointer transition-colors"
                  >
                    <i className="ri-close-line text-xs text-stone-500 hover:text-rose-500"></i>
                  </button>
                </div>
              ))}
              
              {/* Empty Slots */}
              {[...Array(3 - compareItems.length)].map((_, i) => (
                <div
                  key={`empty-${i}`}
                  className="w-12 h-12 rounded-full border-2 border-dashed border-stone-200 flex items-center justify-center"
                >
                  <i className="ri-add-line text-stone-300"></i>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Actions */}
          <div className="flex items-center gap-3">
            <button
              onClick={clearCompare}
              className="px-4 py-2 text-stone-500 hover:text-stone-700 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              Clear All
            </button>
            <button
              onClick={openCompare}
              disabled={compareItems.length < 2}
              className={`px-6 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap flex items-center gap-2 ${
                compareItems.length >= 2
                  ? 'bg-stone-900 text-white hover:bg-gradient-to-r hover:from-amber-400 hover:to-yellow-300 hover:text-stone-900'
                  : 'bg-stone-200 text-stone-400 cursor-not-allowed'
              }`}
            >
              <i className="ri-scales-3-line"></i>
              Compare Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
